import $ from 'jquery';
import Config from '../../../base/pride.config';
import ReloadableComponentPrototype from 'ReloadableComponentPrototype';
import RequestUtils from '../../../base/request/request';
import Cookies from 'cookies';
import { sendEvent } from '../../../base/chat/chatEvents';

/* globals DIALOGUE */

const selectors = {
  username: '.cms-login__screen-username',
  form: '.cms-login__form--credentials',
  loginLoader: '.cms-login__loader',
  inputFields: 'input[name=username], input[name=password]',
  inputUsername: 'input[name=username]',
  inputPassword: 'input[name=password]',
  inputPortalType: 'input[name=portal_type]',
  inputUlmDomain: 'input[name=ulm_domain]',
  inputPhone: 'input[name=phone_number]',
  inputSpamCode: 'input[name=no_spam_code]',
  logoutButton: '.cms-login__logout-button',
  ulmLogoutLink: '.ulmlogin__logout-link',
  credentialsLoginError: '.cms-login__error--credentials .cms-login__error',
  userHasLoggedIn: '.cms-login__screen-username',
  partsContainer: '.cms-login__parts',
  componentLoaderWrapper: '.component-loader__wrapper',
  loggedInWrapper: '.cms-login--logged-in',
};

const classNames = {
  inputError: 'has-error',
  componentLoaderWrapperActive: 'component-loader__wrapper--active',
};

const tupasOkQueryParam = 'tupas-ok';

export default class Login2020 extends ReloadableComponentPrototype {

  build() {
    this.elements = {};
    this.shouldUpdate = true;
    this.justLoggedIn = false;
    window.sessionStorage.setItem('pageUrl', window.location.href);

    this.buildContent();
    this.maintainUlmSession();

    if (!window.dialogueMetadata && this.data.lekaneUserData !== 'undefined') {
      window.dialogueMetadata = () => ({
        MdAuthJWT: this.data.lekaneUserData,
      });
      const chathost = this.data.chatHost;
      this.chatScript(chathost);
    } else {
      // If the lekane user data is empty, which means the user is not logged in , then also chat needs to be shown. Hence the below logic.
      const chathost = this.data.chatHost;
      this.chatScript(chathost);
    }

    if (RequestUtils.getQueryParam(tupasOkQueryParam)) {
      sendEvent('TeliaVisitorSignedIn',
        JSON.stringify({
          MdAuthEncrypted: this.data.lekaneUserData,
          login: 1,
        }));
    }

    // Metrics event
    const isLoggedInEventSent = Cookies.get('loginEventSent');
    if ((isLoggedInEventSent === undefined) && this.hasLoggedIn()) {
      this.sendLoginEvent();
      this.sendAnalyticsInfo();
      window.sessionStorage.removeItem('selectedBankName');
      Cookies.set('loginEventSent', true, { secure: true, httpOnly: true });
    }

    return true;
  }

  /**
   * Build login form
   */
  buildForm() {
    this.elements.inputUsername = this.node.find(selectors.inputUsername);
    this.elements.inputPassword = this.node.find(selectors.inputPassword);
    this.elements.inputPortalType = this.node.find(selectors.inputPortalType);
    this.elements.loggedOutWrapper = this.node.find(selectors.loggedOutWrapper);
    this.elements.credentialsLoginError = this.node.find(selectors.credentialsLoginError);

    this.selectPreferredLoginMethod();

    // Form submit
    this.node.on('submit', selectors.form, (e) => {
      e.preventDefault();

      const currentForm = $(e.currentTarget);
      const currentUsername = currentForm.find(selectors.inputUsername);
      const currentPassword = currentForm.find(selectors.inputPassword);
      const currentPortalType = currentForm.find(selectors.inputPortalType);
      const currentUlmDomain = currentForm.find(selectors.inputUlmDomain);
      const ulmB2BRedirectUrl = 'http://www.telia.fi/yrityksille/ulmauthcode?portalUrl=B2B_Login';

      this.onSubmit(currentUsername.val().replace(/ /g, ''), currentPassword.val(), currentPortalType.val(), currentUlmDomain.val(), ulmB2BRedirectUrl);
    });

    // Input field
    this.node.on('input', selectors.inputFields, () => this.onInput());

    this.eventBus.publishTo(this.id, 'build_form');
  }

  buildTupasLoginLink() {
    // Already logged in
    if (this.hasLoggedIn()) {
      return;
    }

    const tupasLink = this.node.find('.cms-login__panel--tupas .button');
    // Not defined
    if (tupasLink.length === 0) {
      return;
    }
    let url = tupasLink.attr('href');
    if (url.indexOf('successURL') === -1) {
      let successUrl;
      if (this.data.sessionRedirect) {
        const sessionRedirectUrl = window.atob(decodeURIComponent(this.data.sessionRedirect));
        successUrl = sessionRedirectUrl;
      } else {
        successUrl = window.location.href;

        // Identifying the redirect parameter URL as actual success Url and redirecting to the same
        if (successUrl.indexOf('redirect=') !== -1) {
          successUrl = successUrl.substring((successUrl.indexOf('redirect=') + 9));
        }
        // This redirect is used for user clicking on OS link from Minun Telia Menu item.
        if (this.redirectUrl) {
          successUrl = this.redirectUrl;
        }
        // const contextPath = successUrl.substring(successUrl.indexOf('telia.fi') + 8).trim();
        //  successUrl = `${contextPath}`;
        if (url.indexOf(tupasOkQueryParam) === -1) {
          successUrl += successUrl.indexOf('?') === -1 ? `?${tupasOkQueryParam}=true` : `&${tupasOkQueryParam}=true`;
        }
      }

      // the successURL is intentionally used ignoring camel cases as the Backend Tupas expects it this way.
      url += `?successURL=${encodeURIComponent(successUrl)}`;
    }
    tupasLink.attr('onclick', `window.location.href='${url}'`);
  }

  /**
   * Build logged in content
   */
  buildContent() {
    // Not logged in
    if (!this.hasLoggedIn()) {
      return;
    }

    // Logout
    this.node.on('click', selectors.logoutButton, (e) => {
      e.preventDefault();

      if (this.node.data('componentData').isNavigationLogin) {
        this.eventBus.publish('navigation_logout');
      }

      Cookies.set('loginType'); // When no values are being passed , it invalidates the existing cookie.
      Cookies.set('loginEventSent');

      this.showComponentLoader();
      this.onLogout();
    });

    // ULM Logout
    this.node.on('click', selectors.ulmLogoutLink, (e) => {
      e.preventDefault();
      this.onULMLogout();
    });

    this.eventBus.subscribe(this, 'update_login_action_number', this.updateLoginActionNumber);
  }

  updateLoginActionNumber(action, number = 0, reloadData = false) {
    const actionNumber = this.node.find(`.cms-login__action-link--${action} .cms-login__action-number`);

    if (actionNumber.length === 0) {
      return;
    }

    // Hide number
    actionNumber.removeClass('cms-login__action-number--visible');

    actionNumber.text(number > 9 ? '9+' : number);

    // Show number
    if (number > 0) {
      actionNumber.addClass('cms-login__action-number--visible');
    }

    // Set cookie that forces reloading user data
    if (reloadData === true) {
      document.cookie = 'reload-user-data=true; path=/';
    }
  }

  /**
   * Clear input errors
   */
  clearError() {
    this.elements.inputUsername.removeClass(classNames.inputError);
    this.elements.inputPassword.removeClass(classNames.inputError);
    this.elements.loggedOutWrapper.removeClass(classNames.loginError);
    this.elements.credentialsLoginError.removeClass('cms-login__error--visible');
  }


  /**
   * Check whether user has logged in
   * @returns {Boolean}
   */
  hasLoggedIn() {
    return this.node.find(selectors.userHasLoggedIn).length > 0;
  }



  /**
   * On input
   */
  onInput() {
    // Clear input errors
    this.clearError();
  }


  /**
   * On logout
   */
  onLogout() {
    try {
      const data = {
        event: 'logout',
        login_role: this.getLoggedInUserRole(),
      };
      window.dataLayer.push(data);
    } catch (e) {
      console.log(e); // eslint-disable-line
    }

    $.ajax({
      url: Config.login.url,
      type: 'DELETE',
    })
      .done(() => {
        sendEvent('TeliaVisitorSignedOut', 1);
      })
      .always(() => {
        if (typeof DIALOGUE === 'undefined' || typeof DIALOGUE.tracking === 'undefined') {
          this.redirectOrReloadPage();
        }
        DIALOGUE.tracking.signOutChat(
          () => {
            this.redirectOrReloadPage();
          },
          (e) => {
            console.error(e); // eslint-disable-line
          },
        );
        this.hideComponentLoader();
      });
    const isUlmB2bUser = this.node.data('componentData').isUlmB2bUser;
    const isYhteisoUser = this.node.data('componentData').isYhteisoUser;
    window.sessionStorage.clear();
    if (isUlmB2bUser || isYhteisoUser) {
      this.onUlmSessionLogout();
    }
  }

  redirectOrReloadPage() {
    if (window.location.href.includes('/OmatSivut/')) {
      window.location.href = '/kirjauduUlos';
    } else {
      document.location.reload(true);
    }
  }

  /**
   * On ULM logout
   */
  onULMLogout() {
    const ulmDomain = this.node.data('componentData').ulmDomain;
    $.ajax({
      url: `${ulmDomain}/session/end`,
      type: 'GET',
      xhrFields: {
        withCredentials: true,
      },
    }).done(() => {
      window.location.href = 'https://www.telia.fi/login/Logout?dest_url=https://www.telia.fi/OmatSivut/';
    });
  }

  /**
   * On ULM Session Logout
   */
  onUlmSessionLogout() {
    const ulmLogoutPortalUrl = this.node.data('componentData').ulmLogoutPortalUrl;
    const currentPage = window.location.href;
    window.location.href = `${ulmLogoutPortalUrl}?redirectTo=${currentPage}`;
  }


  showComponentLoader() {
    if ((this.componentLoaderWrapper !== null) && this.componentLoaderWrapper.length) {
      this.componentLoaderWrapper.addClass(classNames.componentLoaderWrapperActive);
    }
  }

  hideComponentLoader() {
    if ((this.componentLoaderWrapper !== null) && this.componentLoaderWrapper.length) {
      this.componentLoaderWrapper.removeClass(classNames.componentLoaderWrapperActive);
    }
  }

  /**
   * Gets the current login category
   */
  getLoginCategory() {
    if (this.node.find('.cms-login__tab-radio--b2b-portal:checked').length > 0) {
      return 'B2B portal';
    }

    return 'Omat sivut';
  }

  /**
   * Gets the current redirect url based on which login tab is selected.
   * The b2c redirect url is used on the b2b credentials login too.
   */
  getRedirectUrl() {
    const redirectUrlB2b = this.node.data('login-redirect-b2b');
    let redirectUrlB2c = this.node.data('login-redirect-b2c');

    if (redirectUrlB2c.length === 0) {
      redirectUrlB2c = redirectUrlB2b;
    }

    let redirectUrl = redirectUrlB2b;

    if (this.getLoginCategory() === 'Omat sivut') {
      redirectUrl = redirectUrlB2c;
    }

    return redirectUrl;
  }

  /**
   * Function to be called when login is finished
   * @param {Object} node
   */
  onReloadReady(node) {
    // This is for b2b redirection based on tab selection
    const redirectUrl = this.getRedirectUrl();

    if (redirectUrl.length > 0 && this.justLoggedIn) {
      document.location.assign(redirectUrl);
      return;
    }

    super.onReloadReady(node);

    // Check if there is a redirectUrl query param available and redirect to it after login
    const params = new URLSearchParams(window.location.search);
    if (this.checkAndValidateRedirectParam(params)) {
      const queryParamRedirectUrl = params.get('redirect');
      document.location.assign(queryParamRedirectUrl);
      return;
    }

    // This redirect is used for user entering OS page directly.
    if (typeof this.sessionRedirect !== 'undefined' && this.justLoggedIn) {
      // Example cookie: ACTSESSION=L3BhbHZlbHV0L29oamVsbWFvcGFz
      // The value is an encoded path which we first must decode
      const destPath = window.atob(decodeURIComponent(this.sessionRedirect));
      document.location.assign(destPath);
      return;
    }

    // This redirect is used for user clicking on OS link form telia.fi page.
    if (this.redirectUrl) {
      window.location.href = this.redirectUrl;
      return;
    }

    const usernameElem = this.node.find(selectors.username);

    // Username exists
    if (usernameElem.length) {
      this.eventBus.publish('navigation_login_username_changed', usernameElem.attr('data-username'));
    }

    this.eventBus.publish('reload_navigation_login');
    this.eventBus.publish('reload_components');

    const loggedInWrapper = $(selectors.loggedInWrapper);
    sendEvent('TeliaVisitorSignedIn',
      JSON.stringify({
        MdAuthEncrypted: loggedInWrapper.data('userDataForLekane'),
        login: 1,
      }));

    this.removeLoginUrlParameter();
  }

  removeLoginUrlParameter() {
    window.history.replaceState(null, null, window.location.href.replace(/(\?|&)kirjaudu/, ''));
  }

  /**
   * Show input errors
   */
  showError() {
    this.elements.inputUsername.addClass(classNames.inputError);
    this.elements.inputPassword.addClass(classNames.inputError);
    this.elements.credentialsLoginError.addClass('cms-login__error--visible');
  }

  /**
   * Maintain session between ULM and telia.fi site
   */
  maintainUlmSession() {
    // Already logged in
    const ulmDomain = this.node.data('componentData').ulmDomain;
    if (this.hasLoggedIn() && this.validULMRelatedCookies()) {
      $.ajax({
        url: `${ulmDomain}/session/level`,
        type: 'GET',
        xhrFields: {
          withCredentials: true,
        },
      });
    }
  }

  /**
   * validate ulmloggedin(from ULM) and TELIAULMLOGGEDIN(from telia.fi) cookie
   * @return {bool} cookie value
   */
  validULMRelatedCookies() {
    const ulmLoggedIn = Cookies.get('ulmloggedin');
    const teliaUlmLoggedIn = Cookies.get('TELIAULMLOGGEDIN');
    return ulmLoggedIn === 'true' && teliaUlmLoggedIn === 'true';
  }

  /**
   * Send metrics on login
   *
   */
  sendLoginEvent() {
    const selectedBankName = window.sessionStorage.getItem('selectedBankName');
    if (typeof window.dataLayer === 'undefined') {
      // Do Nothing
    } else {
      let data;
      if (this.node.data('componentData').encryptedBPN) {
        const encryptedBpn = this.node.data('componentData').encryptedBPN;
        data = {
          event: 'login_successful',
          login_method: selectedBankName,
          login_section: this.getLoginSection(),
          login_role: this.getLoggedInUserRole(),
          bpn: encryptedBpn,
        };
      } else {
        data = {
          event: 'login_successful',
          login_method: selectedBankName,
          login_section: this.getLoginSection(),
          login_role: this.getLoggedInUserRole(),
        };
      }
      window.dataLayer.push(data);
    }
  }

  /**
   * Gets the current login section
   */
  getLoginSection() {
    const selectedLoginSection = window.sessionStorage.getItem('currentLoginSection');

    if (selectedLoginSection === selectors.ownerPage) {
      return 'B2C_OWNER';
    }

    if (selectedLoginSection === selectors.userPage) {
      return 'B2C_USER';
    }

    if (selectedLoginSection === selectors.adminPage) {
      return 'B2B_ADMIN';
    }

    return 'B2C_USER';
  }

  /**
   * Gets the current logged in user role
   */
  getLoggedInUserRole() {
    const isB2bUser = this.data.isB2bUser;
    const isCustomer = this.data.isCustomer;
    const isOmatSivutUser = this.data.isOmatSivutUser;
    const isUlmB2bUser = this.data.isUlmB2bUser;
    const isYhteisoUser = this.data.isYhteisoUser;

    if (isCustomer) {
      return 'B2C Owner';
    }

    if (isB2bUser || isUlmB2bUser) {
      return 'B2B Admin';
    }

    if (isOmatSivutUser) {
      return 'B2C User';
    }

    if (isYhteisoUser) {
      return 'Yhteisö User';
    }

    return 'B2C User';
  }

  /**
   * On login failed
   */
  sendTupasLoginFailureEvent() {
    // Metrics event
    const selectedBankName = window.sessionStorage.getItem('selectedBankName');
    if (typeof window.dataLayer === 'undefined') {
      // Do Nothing
    } else {
      const data = {
        event: 'login_failed',
        login_method: selectedBankName,
        login_section: this.getLoginSection(),
        login_failure_reason: this.cancelledStatus,
      };
      window.dataLayer.push(data);
    }
    window.sessionStorage.removeItem('selectedBankName');
  }

  checkAndValidateRedirectParam(params) {
    if (params.has('redirect')) {
      let redirectUrl = params.get('redirect');
      const startsWithHttp = redirectUrl.startsWith('http://');
      const startsWithHttps = redirectUrl.startsWith('https://');
      const containsTeliaFiDomain = redirectUrl.includes('.telia.fi');
      const containsRedirectParam = redirectUrl.includes('redirect');
      if (containsRedirectParam) {
        return false;
      }
      if ((startsWithHttp || startsWithHttps) && containsTeliaFiDomain) {
        return true;
      }
    }
    return false;
  }

  chatScript(chathost) {
    window.talkNowEntityId = 'TeliaFi';
    window.talkNowHostName = chathost;
    const talkNowSSLPort = '443';
    window.talkNowUseProxy = false;
    window.proxyURL = '';
    window.lekaneServerURL = 'https://' + window.talkNowHostName + ':' + talkNowSSLPort;
    (function (w) {
      function d() {
        const ds = document.createElement('script');
        ds.type = 'text/javascript';
        ds.async = true;
        ds.src = w.lekaneServerURL + '/lekane/boot?ei=' + w.talkNowEntityId;
        document.head.appendChild(ds);
      }
      if (document.readyState === 'uninitialized' || document.readyState === 'loading') {
        w.addEventListener ? w.addEventListener('load', d, false) : w.attachEvent('onload', d);
      } else {
        d();
      }
    })(window);
  }

  sendAnalyticsInfo() {
    const loginSection = this.getLoginSection();
    const loginRole = this.getLoggedInUserRole();
    const selectedBankName = window.sessionStorage.getItem('selectedBankName');
    const data = { loginMethod: selectedBankName, loginSection: loginSection, loginRole: loginRole };
    Cookies.set('loginAnalyticsInfo', JSON.stringify(data), { expires: 300, secure: true, httpOnly: true });
  }

}
